"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Jo = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 840 420", ...props },
    react_1.default.createElement("path", { fill: "#007a3d", d: "M0 0h840v420H0z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "M0 0h840v280H0z" }),
    react_1.default.createElement("path", { d: "M0 0h840v140H0z" }),
    react_1.default.createElement("path", { fill: "#ce1126", d: "M0 0v420l420-210z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "m129.787 180 6.508 16.485 16.947-5.19-8.83 15.367 14.623 10.014-17.52 2.676 1.289 17.677L129.787 225l-13.016 12.03 1.289-17.678-17.52-2.676 14.623-10.014-8.83-15.367 16.946 5.19L129.787 180z" })));
exports.default = Jo;
//# sourceMappingURL=Jo.js.map